import PasswordRequirementsV9 from '../../components/PasswordRequirementsV9';
import { isValidNewPasswordV9 } from '../../helpers/passwordPolicyV9';
import { isValidUsernameV108 } from '../../helpers/usernamePolicyV108';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Card } from 'semantic-ui-react';
import { API, showError, showSuccess } from '../../helpers';

const AddUser = () => {
  const { t } = useTranslation();
  const originInputs = {
    username: '',
    display_name: '',
    password: '',
  };
  const [inputs, setInputs] = useState(originInputs);
  const { username, display_name, password } = inputs;

  const handleInputChange = (e, { name, value }) => {
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const submit = async (event) => {
    event?.preventDefault();
    if (!isValidNewPasswordV9(password)) {
      showError(t('password_v9.error'));
      return;
    }
    if (inputs.username === '' || inputs.password === '') return;
    if (!isValidUsernameV108(username)) {
      showError(t('organization.validation.username_length'));
      return;
    }
    const res = await API.post(`/api/user/`, inputs);
    const { success, message } = res.data;
    if (success) {
      showSuccess(t('user.messages.create_success'));
      setInputs(originInputs);
    } else {
      showError(message);
    }
  };

  return (
    <div className='dashboard-container management-container-v4'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>{t('user.add.title')}</Card.Header>
          <Form autoComplete='off' onSubmit={submit}>
            <Form.Field>
              <Form.Input
                label={t('user.edit.username')}
                name='username'
                placeholder={t('user.edit.username_placeholder')}
                onChange={handleInputChange}
                value={username}
                error={
                  Boolean(username) &&
                  !isValidUsernameV108(username) && {
                    content: t('organization.validation.username_length'),
                  }
                }
                autoComplete='off'
                required
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                label={t('user.edit.display_name')}
                name='display_name'
                placeholder={t('user.edit.display_name_placeholder')}
                onChange={handleInputChange}
                value={display_name}
                autoComplete='off'
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                label={t('user.edit.password')}
                name='password'
                type='password'
                placeholder={t('user.edit.password_placeholder')}
                onChange={handleInputChange}
                value={password}
                autoComplete='new-password'
                required
              />
            </Form.Field>
            <PasswordRequirementsV9 password={password} />
            <Button
              positive
              type='submit'
              disabled={
                !isValidNewPasswordV9(password) ||
                !isValidUsernameV108(username)
              }
            >
              {t('user.edit.buttons.submit')}
            </Button>
          </Form>
        </Card.Content>
      </Card>
    </div>
  );
};

export default AddUser;
